import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Link,
  CircularProgress,
} from '@mui/material';
import FileUpload from '../RunWorkflowModal/FileUpload';

const ACCEPTED_EXTENSIONS = '.csv,.xlsx,.xls';
const ALLOWED_EXTENSIONS = ['.csv', '.xlsx', '.xls'];

const ImportCutoffsDialog = ({ open, onClose, onImport, importing }) => {
  const [accepted, setAccepted] = useState([]);
  const [fileError, setFileError] = useState('');

  useEffect(() => {
    if (open) {
      setAccepted([]);
      setFileError('');
    }
  }, [open]);

  const handleAcceptedFiles = (files, rejections) => {
    setFileError('');

    if (rejections && rejections.length > 0) {
      setAccepted([]);
      setFileError('Only CSV or Excel (.csv, .xlsx, .xls) files are accepted.');
      return;
    }

    if (files && files.length > 0) {
      const file = files[0];
      const ext = '.' + file.name.split('.').pop().toLowerCase();
      if (!ALLOWED_EXTENSIONS.includes(ext)) {
        setAccepted([]);
        setFileError('Only CSV or Excel (.csv, .xlsx, .xls) files are accepted.');
        return;
      }
      setAccepted([file]);
    }
  };

  const handleImport = () => {
    if (accepted.length === 0) return;
    onImport(accepted[0]);
  };

  const handleClose = () => {
    if (importing) return;
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      aria-labelledby="import-cutoffs-dialog-title"
    >
      <DialogTitle id="import-cutoffs-dialog-title" sx={{ textAlign: 'center' }}>Import Cutoffs</DialogTitle>
      <DialogContent sx={{ pb: 1 }}>
        <Box sx={{ overflow: 'hidden' }}>
          <FileUpload
            accepted={accepted}
            accept={ACCEPTED_EXTENSIONS}
            dropZoneMsg="Drop a CSV or Excel file here"
            acceptedFiles={handleAcceptedFiles}
            errorMsg={fileError}
          />
        </Box>
        <Box sx={{ textAlign: 'center', mt: 2 }}>
          <Link
            href="/documents/Cutoff_Import_Template_v1_3.xlsx"
            download="Cutoff_Import_Template_v1_3.xlsx"
            underline="hover"
          >
            Download the ED3N Cutoff Import Template
          </Link>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} variant="outlined" disabled={importing}>
          Cancel
        </Button>
        <Button
          onClick={handleImport}
          variant="contained"
          color="primary"
          disabled={accepted.length === 0 || importing}
          startIcon={importing ? <CircularProgress size={16} color="inherit" /> : null}
        >
          {importing ? 'Importing...' : 'Import'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ImportCutoffsDialog;
